import platform from "./imgs/categories/platform.png";
import PL from "./imgs/categories/programming-language.png";
import FE from "./imgs/categories/front-dev.png";
import BE from "./imgs/categories/back.png";
import CS from "./imgs/categories/comptuer-science.png";
import BD from "./imgs/categories/big-data.png";
import Theory from "./imgs/categories/theory.png";
import Books from "./imgs/categories/books.png";
import Gaming from "./imgs/categories/gaming.png";
import DE from "./imgs/categories/monitor.png";
import Entertainment from "./imgs/categories/entertainment.png";
import Editors from "./imgs/categories/env.png";
import Databases from "./imgs/categories/database.png";
import Media from "./imgs/categories/media.png";
import Learn from "./imgs/categories/learn.png";
import Security from "./imgs/categories/security.png";
import CMS from "./imgs/categories/cms.png";
import Hardware from "./imgs/categories/hardware.png";
import Business from "./imgs/categories/business.png";
import Work from "./imgs/categories/work.png";
import Networking from "./imgs/categories/networking.png";
import DS from "./imgs/categories/decentralized.png";
import Miscellaneous from "./imgs/categories/Miscellaneous.png";

export default {
  Platforms: platform,
  "Programming Languages": PL,
  "Front-End Development": FE,
  "Back-End Development": BE,
  "Computer Science": CS,
  "Big Data": BD,
  Theory,
  Books,
  Editors,
  Gaming,
  "Development Environment": DE,
  Entertainment,
  Databases,
  Media,
  Learn,
  Security,
  "Content Management Systems": CMS,
  Hardware,
  Business,
  Work,
  Networking,
  "Decentralized Systems": DS,
  Miscellaneous
};



// WEBPACK FOOTER //
// ./src/categories.js